import { _trim,
  _matchRequest,
} from '../utils';
import { jobActions } from '../actionTypes';
import createLogger from '../../utils/createLogger';

const DEBUG = true;
const debug = createLogger(DEBUG, `requestsReducer.js`);


export default (state = {}, action) => {
  const { type } = action;
  const request = _matchRequest(type);

  if (!request) {
    let nextState = {...state};
    switch (type) {
      case jobActions.FLUSH_POSTINGS_CACHE:
        if (nextState.hasOwnProperty(`GET_JOB_POSTINGS_PAGE`)) {
          delete nextState[`GET_JOB_POSTINGS_PAGE`];
        }
        return nextState;

      case jobActions.FLUSH_LEADS_CACHE:
        if (nextState.hasOwnProperty(`GET_JOB_LEADS_PAGE`)) {
          delete nextState[`GET_JOB_LEADS_PAGE`];
        }
        return nextState;

      default:
        return nextState;
    }
  }

  debug.enter(`requestReducer`);
  debug.log(`  request:`, request);

  return {
    ...state,
    [request.name]: _trim({
      name: request.name,
      loading: request.state === 'REQUEST',
      error: request.state  === 'FAILURE' ? action.error : null,
      offset: action.offset,
      count: action.count,
      total: action.total,
    }),
  };
};



// WEBPACK FOOTER //
// ./src/data/requests/requestsReducer.js